import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, Validators } from '@angular/forms';

import { IVROptionSchema, SupportedLanguages } from '@pwp-common';

import { KVPair } from '../../../../common/objects/kvpair';
import { ArrayValidator } from '../../../../common/validators/array-validator/array-validator';
import { ObjEditor } from '../../../generic/abstract-classes/obj-editor';
import { PhrasesLangPair } from '../generic/phrases-lang-pair';

@Component({
  selector: 'app-phrases-lang-pair-editor',
  templateUrl: './phrases-lang-pair-editor.component.html',
  styleUrls: ['./phrases-lang-pair-editor.component.css'],
})
export class PhrasesLangPairEditorComponent extends ObjEditor<KVPair<PhrasesLangPair>> implements OnInit {
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  possibleLanguages = SupportedLanguages.all;

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Lifecycle
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    // @ts-ignore
    private _changeDetectorRef: ChangeDetectorRef,
    private formBuilder: UntypedFormBuilder,
  ) {
    super(_changeDetectorRef);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Read Form
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getObjFromForm() {
    const languageDefaults = SupportedLanguages.getDefaults(this.language.value);
    const value = new PhrasesLangPair(languageDefaults, this.phrases.value);
    return new KVPair({ id: this.obj.id, value });
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Write Form
  ///////////////////////////////////////////////////////////////////////////////////////////

  setFormFromObj(obj: KVPair<PhrasesLangPair>) {
    // Init Form
    const formConfig = {} as any;
    formConfig.language = [obj.value!.languageDefaults.getShortCode(), [Validators.required]];
    formConfig.phrases = [
      obj.value!.phrases,
      [
        Validators.required,
        ArrayValidator.maxLength(IVROptionSchema.Constants.ivrHintItemMaxNumChars),
        ArrayValidator.regex(/^[^,]*$/),
      ],
    ];
    this.form = this.formBuilder.group(formConfig);
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Form: Getters
  ///////////////////////////////////////////////////////////////////////////////////////////

  get language(): AbstractControl | null {
    return this.form.get('language');
  }

  get phrases(): AbstractControl | null {
    return this.form.get('phrases');
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Is Valid Obj
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  isValidObjScoper = (): boolean => this.isValidObj();

  isValidObj() {
    if (!super.isValidObj()) {
      return false;
    }

    return true;
  }
}
